import React from 'react';
import PropTypes from 'prop-types';
import WorksAccordionItem from './WorksAccordionItem';

export default class WorksAccordion extends React.Component {

    render() {
        const { allowNavigateToWork, works } = this.props;

        return (
            <div className="panel-group" role="tablist" aria-multiselectable="true">
                {
                    works.map((work, index) =>
                        <WorksAccordionItem
                            key={index}
                            work={work}
                            index={index}
                            allowNavigateToWork={allowNavigateToWork}
                        />,
                    )
                }
            </div>
        );
    }

}

WorksAccordion.propTypes = {
    works: PropTypes.any,
    allowNavigateToWork: PropTypes.bool,
};

WorksAccordion.defaultProps = {
    allowNavigateToWork: true,
};



// WEBPACK FOOTER //
// ./src/app/outsource/components/WorksAccordion.js